module.exports = __webpack_public_path__ + "static/img/cont7.c809a7b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont7.jpg
// module id = +yus
// module chunks = 0